import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from 'src/app/api.service';
import { DataService } from 'src/app/services/data.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-multi-unit-calculator',
  templateUrl: './multi-unit-calculator.component.html',
  styleUrls: ['./multi-unit-calculator.component.scss']
})
export class MultiUnitCalculatorComponent implements OnInit {
  //mdlRef: any;

  @Input() itemUnit: any = 0;
  @Input() invQty: number = 0;
  @Input() invoiceUnit: any = 0;
  @Input() mdlRef: any;
  @Input() skuPrecision: number = 0;
  unitCount: any = '';
  finalCount: number = 0;

  // constructor() { }
  constructor(private _Activatedroute: ActivatedRoute, private router: Router, private modalService: NgbModal, private appService: DataService, private apiService: APIService,public commonService: CommonService) { }


  ngOnInit(): void {
  }

  closeModal() {
    this.mdlRef.close();
  }

  pricisionCheck() {
    this.unitCount = this.commonService.PrecisionwiseValue(this.unitCount + '', this.skuPrecision);
  }



  calculateUnit(){
    if(this.unitCount > 0){
      this.finalCount = this.commonService.PrecisionwiseValue(Number(this.unitCount) * Number(this.invQty)+ '', this.skuPrecision);
      // this.finalCount = this.commonService.PrecisionwiseValue(this.finalCount + '', this.skuPrecision);
      let calCulaterArr = [{ calQty: this.finalCount }];
      this.mdlRef.close(calCulaterArr);
      // this.mdlRef.close(true);
    }
    else{
      this.apiService.successAlert('Please enter the quantity in ' + this.itemUnit +  ' equivalent of 1 ' + this.invoiceUnit + '.');
    }
  }

  numberOnly(event: any): boolean {
    return this.commonService.numberOnly(event);
    } 
}
